export var WORKSPACE_SEARCH_REPOSITORY = 'WORKSPACE_SEARCH_REPOSITORY';